<template>
	<ja-modal :show="show" class="import-data-modal">
		<ja-close-button name="close" @click.native="closeModal"></ja-close-button>

		<div class="modal-content">
			<h3 class="title">{{ $t('importData') }}</h3>
			<div>
				<div class="import-result-container">
					<div v-if="success" class="import-result-imported">
						<svgicon name="info" class="info"></svgicon>
						{{ message }}
					</div>

					<div v-if="failure" class="import-result-failed">
						<svgicon name="info" class="info"></svgicon>
						{{ message }}
					</div>
				</div>
			</div>
			<div class="button-wrapper">
				<ja-button
					name="importFile"
					class="small btn-right"
					:success="success"
					@click.native="handleFileUpload"
					>{{ $t('importFile') }}</ja-button
				>

				<input
					id="file-upload"
					ref="file"
					type="file"
					@change="importFromFile($event)"
				/>
			</div>
		</div>
	</ja-modal>
</template>
<script>
import Modal from '@/components/Modal/Modal';
import Button from '../../ui/Button';
import UserData from '@/mixins/UserData';
import DateFormat from '@/mixins/DateFormat';
import CloseButton from '../../ui/CloseButton';
import axios from 'axios';

export default {
	components: {
		jaButton: Button,
		jaModal: Modal,
		jaCloseButton: CloseButton
	},
	mixins: [UserData, DateFormat],

	props: {
		show: {
			type: Boolean,
			default: false
		},
		facilities: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			formData: null,
			success: false,
			failure: false,
			message: null,
			showWarning: true,
			agreed: false
		};
	},
	computed: {
		fileInput() {
			return document.getElementById('file-upload');
		},
		hasFacilities() {
			return false; //this.formData.facilityId != 0;
		}
	},
	methods: {
		closeModal() {
			if (this.success) {
				// Reload page
				this.$router.go();
			}
			this.$emit('closeModal');
		},
		handleFileUpload() {
			if (!this.success) {
				this.fileInput.value = null;
				this.fileInput.click();
				return;
			}
			this.$router.go();
		},
		importFromFile(event) {
			this.failure = false;
			if (this.success) {
				// reload page
				this.$router.go();
				return;
			}

			var file = event.target.files[0];
			var fileNameArray = file.name.split('.');
			var fileExtension = fileNameArray[fileNameArray.length - 1];

			if (fileExtension !== 'json') {
				this.failure = true;
				this.message = this.$t('errorImportFile');
			} else {
				this.$emit('loadingStartForAdmin');

				var formData = new FormData();
				formData.append('file', file);
				axios
					.post(`/api/Data/ImportApiKey`, formData, {
						headers: {
							'Content-Type': 'multipart/form-data'
						},
						withCredentials: true
					})
					.then(response => {
						if (response.data) {
							this.success = true;
							this.failure = false;
							this.message = this.$t('sucessfull');
						} else {
							this.failure = true;
							this.success = false;
							this.message = this.$t('errorSync');
						}

						this.$emit('loadingStopForAdmin');
					});
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.import-data-modal {
	::v-deep .modal {
		margin: auto;
		min-height: 240px;
		max-height: 768px;
		top: unset;
	}
	::v-deep.modal-content {
		border-radius: 8px;
	}
	.close-button {
		background-color: $font-blue;
		position: absolute;
		height: 38px;
		width: 38px;
		right: 16px;
		top: 16px;
		outline: 0;
		border: 0;
		background-color: $container-bgcolor;
		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;
				svg {
					fill: $hover-state;
				}
			}
		}

		svg {
			fill: $primary-state;
		}
	}

	.modal-content {
		.scrollbar {
			max-height: 720px;
		}
		height: 100%;
		width: 100%;
		padding-top: 24px;
		display: flex;
		flex-direction: column;
		text-align: left;
		background-color: $container-bgcolor;
		border: 1px solid $container-border;

		h3 {
			margin: 16px;
			text-align: center;
		}

		.grid {
			display: flex;
			flex-direction: column;
			padding: 0 32px 32px 32px;

			.grid-row-1 {
				display: flex;
				margin-bottom: 16px;
				> * {
					flex: 0 0 100%;
				}
			}

			.grid-row-2 {
				display: flex;
				align-items: flex-start;

				&:not(:last-child) {
					margin-bottom: 16px;
				}

				> * {
					flex: 0 0 calc(50% - 8px);

					&:first-child {
						margin-right: 16px;
					}
				}
				&.align-bottom {
					align-items: flex-end;
				}
			}

			.grid-col-3 {
				display: flex;
				align-items: flex-end;

				> :first-child {
					margin-right: 16px;
				}

				.grid-cell-2 {
					flex: 0 0 calc(66.66% - 8px);
				}

				.grid-cell-1 {
					flex: 0 0 calc(33.33% - 8px);
				}
			}
		}

		.import-result-container {
			display: flex;
			justify-content: center;
			.import-result-imported,
			.import-result-failed {
				font-family: 'RobotoMedium';
				color: #004cd0;
				margin-bottom: 8px;
				letter-spacing: 0.5px;
				@media (min-width: $breakpoint-mid) {
					font-size: 18px;

					.svg-icon {
						width: 24px;
						height: 24px;
					}
				}
				.svg-icon {
					margin-right: 10px;
				}
			}
		}

		.warning-message {
			display: flex;
			justify-content: center;
			font-family: 'RobotoMedium';
			color: #283eff;
			margin-bottom: 38px;
			letter-spacing: 0.5px;
			padding: 50px 60px 0 60px;
			text-align: center;

			@media (min-width: $breakpoint-mid) {
				font-size: 18px;
			}
		}

		#file-upload {
			display: none;
		}

		.button-wrapper {
			text-align: center;
			margin-bottom: 64px;

			.btn-right {
				margin-left: 20px;
			}
		}
	}
}
</style>
